import { appFormUtil } from 'modules/common';
import React from 'react';
import { StyledDropDown } from 'modules/components/layer01';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';



export type SelectPlanFieldProps<T extends object> = appFormUtil.SelectFieldProps<T>;

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object> (props: SelectPlanFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={[
        ...data,
        {
          id: '', name: '', displayName: 'None'
        }
      ]}
    />
  );
};
